module.exports = __webpack_public_path__ + "static/media/videopano.03719406.xml";